import { Industry, IndustryEntity } from '../..';
import { FirestoreEntity, Mapper } from '../../../@harmony';

export class IndustryToIndustryEntityMapper
  implements Mapper<Industry, FirestoreEntity<IndustryEntity>>
{
  public map(from: Industry): FirestoreEntity<IndustryEntity> {
    return new FirestoreEntity(from.id, {
      _version: 0,
      album: from.album,
      name: from.name,
    });
  }
}

export class IndustryEntityToIndustryMapper
  implements Mapper<FirestoreEntity<IndustryEntity>, Industry>
{
  public map(from: FirestoreEntity<IndustryEntity>): Industry {
    return new Industry(from.id, from.data.album, from.data.name);
  }
}
